
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comment_all",
      function () {
        return require("private-next-pages/comment_all.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comment_all"])
      });
    }
  